/* eslint-disable */
export const state = {
  isLoading: true,
  schedule: [],
  scheduleTotal: 0,
  availableDrivers: [],
  ratings: [],
  ignoringDriverWorking: [],
  filter: {
    carCallSign: '',
    FIO: '',
    carNumber: '',
    carModel: '',
    loadSort: false,
    modelSort: false,
    last_name: '',
    dateTime: [],
    indicators: { }
  },
  scheduleFilters: {
    carModel: '',
    carCallSign: '',
    carNumber: '',
    driverId: '',
    sortCarBrand: false,
    sortShiftCount: false,
    dateTime: [],
    offset: 0,
    limit: 50
  },
  changesStatistics: {
    possible_changes_count: 0,
    fortunate_changes_count: 0
  },
  currentWeek: [],
  currentDriver: {},
  currentDriverInfo: {},
  currentSchedule: {},
  currentSchedulePagination: {
    offset: 0,
    limit: 100,
    total: 0
  },
  currentScheduleInfo: {},
  currentCar: {},
  currentRegionParkID: null,
  currentRegionParkSettingsId: null,
  driverStatusChangingDialog: false,
  chooseDriverDialog: false,
  chooseCarDialog: false,
  showMoreAboutScheduleDialog: false,
  showMoreAboutDriverDialog: false,
  showRemoveFromShiftDriverDialog: false,
  isVisibleDriverEditingDialog: false,
  aboutCarDialog: false,
  driversInChange: [],
  carDialogData: {}
}
